import { useState } from 'react'
import { useProductsApiClient } from '@/api/products/useProductsApiClient.ts'
import { useDownloadExcelFile } from '@/presentation/common/hooks/crud/v2/useDownloadExcelFile.ts'

export const useDownloadProductsExcel = () => {
  const repository = useProductsApiClient()
  const query = useDownloadExcelFile<void>({
    filename : 'products.xlsx',
    callable : repository.downloadExcelResume,
    messages : {
      default : 'Error al generar archivo',
      loading : 'Generando archivo',
      success : 'Archivo generado',
    },
  })

  const [ data, setData ] = useState<File>()

  const submit = async () => {
    const response = await query.submit()
    setData(response)
  }

  return {
    ...query,
    submit,
    data,
  }
}
